/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_TEXT } from '../../../styles/colors/colors';
export var StyledTablePagination = styled('div')(function () {
  return {
    '&.EmbersTablePagination-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '.EmbersTablePagination-arrow': {
        margin: '0 4px',
        fontSize: 20,
        color: PROMETHEAN_TEXT
      },
      '.EmbersTablePagination-arrow-hidden': {
        visibility: 'hidden'
      },
      '.EmbersTablePaginationItem-root': {
        margin: '0 4px'
      }
    }
  };
});